import { render, staticRenderFns } from "./WordMap.vue?vue&type=template&id=bf1c9298&"
import script from "./WordMap.vue?vue&type=script&lang=js&"
export * from "./WordMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports